var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ag-cell-wrapper"},[_c('div',{staticClass:"ag-cell-value",attrs:{"role":"presentation","disabled":""}},[_c('div',{staticClass:"custom-boolean",style:({color: _vm.params.customBooleanColor + ' !important'}),attrs:{"tabindex":"-1"}},[_vm._v(" "+_vm._s(String(!!_vm.params.value).toUpperCase())+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }